<template>
  <div class="flex flex-wrap mb-2" style="position:relative" :style="guideStep >= 40 && guideStep <= 44 ? { zIndex: 100 } : null">
    <loading :active="!this.showRelationship || !showRelationshipMyside"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="false"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <div class="w-full lg:w-3/4 flex-1 min-w-0 bg-white rounded-xl space-y-6 p-3 lg:p-6">
      <div>
        <!-- <span class="text-red-500">*</span> -->
        <span class="text-grap-700 align-middle">{{lang['components']['Event']['Relationship']['title']}}</span>
        <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="`${lang['components']['Event']['Relationship']['title_info']}`"></i>
        <button
          v-if="!editPageType"
          id="relationship"
          class="hover:bg-gray-200 focus:outline-none rounded-xl px-2 py-0.5 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2 text-xs"
          @click="teachVideo()"
        >
          {{lang['components']['Event']['Relationship']['video_teaching']}}
        </button>
      </div>
      <div class="flex-1 space-y-4">
        <div class="space-y-2">
          <div class="flex justify-between">
            <div>
              <!-- <span class="text-red-500">*</span> -->
              <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['Relationship']['default_exclude_audience']}}</span>
              <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="'非必填，最多設定5個'"></i> -->
            </div>
            <!-- 新手教學 -->
            <button
              v-if="!editPageType"
              class="text-blue-600 focus:outline-none rounded-xl px-4 py-1 text-white transition duration-500 ease-in-out border-2 border-blue-600"
              :class="{ 'ring-4 border-blue-400': guideStep === 44 }"
              @click="updateExcludedAudiences()">
              <i class="pi pi-refresh"></i>
              {{lang['components']['Event']['Relationship']['exclude_audience_update_text']}}
            </button>
          </div>
          <!-- 新手教學 -->
          <div class="flex flex-wrap bg-white w-full p-2 rounded-md border" :class="{ 'ring-4 border-blue-400': guideStep === 41 }">
            <template v-for="(tag, index) in viewDatalistData.default_excluded_audiences" :key="tag.code">
              <!-- <div class="rounded m-1 px-2 py-1 text-sm cursor-pointer" :class="[
                tag.checked? 'bg-blue-400' : ' bg-gray-200',
                tag.checked? 'text-white' : 'text-gray-400',
              ]" @click="tag.checked = !tag.checked">
                {{ tag.name }}
              </div> -->
              <div class="rounded m-1 px-2 py-1 text-sm cursor-pointer" :class="[
                tag.checked? 'bg-blue-400' : ' bg-gray-200',
                tag.checked? 'text-white' : 'text-gray-400',
              ]" @click="defaultExcludedAudiences(tag.checked, index, tag.code)">
                {{ getDefaultExcludedName(tag) }}
              </div>
            </template>
          </div>
          <div class="pt-8">
            <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['Relationship']['customize_exclude_audience']}}</span>
          </div>
          <!-- 新手教學 -->
          <MultiSelect
            :disabled="editPageType"
            v-model="viewDatalistData.custom_excluded_audiences_selected"
            :options="viewDatalistData.custom_excluded_audiences"
            optionLabel="name" :placeholder="lang['components']['Event']['Relationship']['customize_exclude_audience_placeholder']"
            :filter="true"
            class="w-full multiselect-custom"
            :class="{ 'ring-4 border-blue-400': guideStep === 43 }"
            @change="onChange($event)"
            display="chip">
          </MultiSelect>
        </div>
      </div>
    </div>
    <div class="hidden lg:block w-1/4 rounded-xl space-y-2 px-4 event-tips-sidebar">
      <div class="flex flex-col bg-white rounded-xl space-y-4 p-4">
        <span class="text-gray-700">{{lang['components']['Event']['Relationship']['selected_exclude_audience']}}</span>
        <!-- 新手教學 -->
        <div class="flex flex-col bg-white w-full p-2 rounded-xl border h-48 overflow-y-auto" :class="{ 'ring-4 border-blue-400': guideStep === 42 }">
          <template v-for="(tag, index) in viewDatalistData.default_excluded_audiences" :key="tag.code">
            <div class="flex justify-between rounded m-1 px-2 py-1 text-sm cursor-pointer w-none bg-blue-400 text-white"
              :class="[
                tag.checked? 'bg-blue-400' : ' bg-gray-200',
                tag.checked? 'text-white' : 'text-gray-400',
              ]" @click="defaultExcludedAudiences(tag.checked, index, tag.code)" v-if="tag.checked">
              <span>{{ getDefaultExcludedName(tag) }}</span>
              <i class="pi pi-times mt-1" v-if="!editPageType" style="fontSize: 0.8rem"></i>
            </div>
          </template>
          <template v-for="tag in viewDatalistData.custom_excluded_audiences_selected" :key="tag.code">
            <div
              class="flex justify-between rounded m-1 px-2 py-1 text-sm cursor-pointer w-none bg-blue-400 text-white"
              @click="removeSelectCustomTags(tag.code)"
            >
              <span>{{ tag.name }}</span>
              <i class="pi pi-times mt-1" v-if="!editPageType" style="fontSize: 0.8rem"></i>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
  <div v-if="view_youtube">
    <Vue3DraggableResizable
      :initW="360"
      :initH="250"
      v-model:x="x"
      v-model:y="y"
      v-model:w="w"
      v-model:h="h"
      v-model:active="active"
      :draggable="true"
      :resizable="false"
      @activated="print('activated')"
      @deactivated="print('deactivated')"
      @drag-start="print('drag-start')"
      @resize-start="print('resize-start')"
      @dragging="doDragging()"
      @resizing="print('resizing')"
      @drag-end="print('drag-end')"
      @resize-end="print('resize-end')"
      class="rounded-xl cursor-move"
      style="background-color: #fff; border:1px #000 solid; z-index:2000;"
    >
      <i class="pi pi-times-circle text-gray-500 cursor-pointer" style="position: absolute; right:5px; top: 5px;" @click="view_youtube = !view_youtube"></i>
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
        <YouTube
          :src="src"
          width="320"
          height="200"
          @ready="onReady"
          @state-change="onStateChange"
          ref="youtube"
          :vars="vars"
        />
      </div>
    </Vue3DraggableResizable>
  </div>
</template>
<script>
  import MultiSelect from 'primevue/multiselect';
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import Vue3DraggableResizable from 'vue3-draggable-resizable'
  import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css'
  import axios from 'axios'
  import Qs from 'qs'

  export default {
    name: 'Relationship',
    components: {
      MultiSelect,
      Loading
    },
    props: {
      // <!-- 新手教學 -->
      guideStep: {
        type: Number,
        default: 1
      },
      // <!-- 新手教學 -->
      showRelationship: {
        type: Boolean
      },
      editPage: {
        type: Boolean
      },
      viewDatalist: {
        type: Object
      },
      campaignId: {
        type: String
      },
      lang: {
        type: Object
      },
      youtubeClose: {
        type: Boolean
      }
    },
    data() {
      return {
        showRelationshipMyside: true,
        selectedCustomTags: [],
        customTags: [
          {
            name: "粉絲專頁的粉絲",
            code: "page_liked",
            checked: false
          },
          {
            name: "AUTOTURN_川霸子麻辣燙加盟總部_互動180天排除165天",
            code: "23847242110170464",
            checked: false
          },
          {
            name: "AUTOTURN_川霸子麻辣燙加盟總部_互動165天排除150天",
            code: "23847242110100464",
            checked: false
          },
          {
            name: "AUTOTURN_川霸子麻辣燙加盟總部_互動120天排除105天",
            code: "23847242109370464",
            checked: false
          },
          {
            name: "AUTOTURN_川霸子麻辣燙加盟總部_互動105天排除90天",
            code: "23847242109200464",
            checked: false
          },
          {
            name: "AUTOTURN_AutoTurn_互動15天",
            code: "23847066987690464",
            checked: false
          },
          {
            name: "AUTOTURN_飛車聯盟_互動165天排除150天",
            code: "23845893920860464",
            checked: true
          },
          {
            name: "AUTOTURN_飛車聯盟_互動135天排除120天",
            code: "23845893920630464",
            checked: false
          }
        ],
        tags: [
          {
            id: 1,
            text: '排除粉絲專頁',
            checked: false
          },
          {
            id: 2,
            text: '排除購買15天',
            checked: false
          },
          {
            id: 3,
            text: '排除購買30天',
            checked: false
          },
          {
            id: 4,
            text: '排除購買60天',
            checked: false
          },
          {
            id: 5,
            text: '排除RT30天',
            checked: true
          },
          {
            id: 6,
            text: '排除RT60天',
            checked: false
          },
          {
            id: 7,
            text: '預設選項',
            checked: false
          },
        ],
        x: 0,
        y: 0,
        h: 200,
        w: 320,
        active: false,
        src: "https://www.youtube.com/watch?v=6vD-2v5RWyk",
        vars: {
          rel: 0,
          start: 0,
          end: 0,
        },
        view_youtube: false,
      }
    },
    watch: {
      'youtubeClose':function(v){
      //  console.log('marketingmethod youtubeClose');
      //  console.log(v);

        let _tmpYoutubeType = v.split('_');

      //  console.log('_tmpYoutubeType');
      //  console.log(_tmpYoutubeType);

      //  console.log(typeof this.view_youtube);
      //  console.log(this.view_youtube);

        if(_tmpYoutubeType[0] != null && _tmpYoutubeType[0] != '' && typeof _tmpYoutubeType[0] != 'undefined'){
          if(_tmpYoutubeType[0] == 'false' || _tmpYoutubeType[1] != 'relationship'){
            this.view_youtube = false
          }
        }

      //  console.log(typeof this.view_youtube);
      //  console.log(this.view_youtube);
      },
    },
    methods: {
    getDefaultExcludedName(tag) {
      const L = this.lang?.['components']?.['Event']?.['Relationship'] || {};
      const keyMap = { page_liked: 'page_liked_name' };
      return L[keyMap[tag.code]] || tag.name;
    },
      onReady() {
      //  console.log('youtube');
        this.$refs.youtube.playVideo()
        // this.$refs.youtube.pauseVideo()
      },
      onStateChange(e){
      //  console.log(e);

        if(e.data == 0){
          this.view_youtube = false
        }
      },
      teachVideo(){
        this.$emit('checkClose')
        // let elem = document.getElementById('marketingDate');
        // let positio = this.getPosition(elem);
        // console.log('x:'+positio.x);
        // console.log('y:'+positio.y);

        // this.x = positio.x + parseInt(80);
        // this.y = positio.y

        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;

        // console.log('windowWidth');
        // console.log(windowWidth);
        // console.log('windowHeight');
        // console.log(windowHeight);

        this.x = windowWidth - parseInt(390);
        this.y = windowHeight - parseInt(350);

        this.view_youtube = true;
        this.$emit('childYoutube', 'true_relationship')

        this.vars.start = 260
        this.vars.end = 295
      },
      getPosition(element) {
        let x = 0;
        let y = 0;

        while ( element ) {
          x += element.offsetLeft - element.scrollLeft + element.clientLeft;
          y += element.offsetTop - element.scrollLeft + element.clientTop;
          element = element.offsetParent;
        }

        return { x: x, y: y };
      },
      print(val) {
      //  console.log(val)
      },
      doDragging(){
      //  console.log('doDragging');
      },
      removeSelectCustomTags(id) {
        if(this.editPageType == false){
          for (let i = 0; i < this.viewDatalistData.custom_excluded_audiences_selected.length; i++) {
            if (this.viewDatalistData.custom_excluded_audiences_selected[i].code === id) {
              this.viewDatalistData.custom_excluded_audiences_selected.splice(i, 1);
            }
          }
        }
      },
      defaultExcludedAudiences(checked, index, code){
        let itemLength = 0

        if(this.editPageType == false){
          for (let i = 0; i < this.viewDatalistData.default_excluded_audiences.length; i++) {
            if (this.viewDatalistData.default_excluded_audiences[i].checked == true) {
              itemLength = parseInt(itemLength) + parseInt(1);
            }
          }

          itemLength = parseInt(itemLength) + this.viewDatalistData.custom_excluded_audiences_selected.length

          if(checked == false){
            if(itemLength < 10){
              for (let i = 0; i < this.viewDatalistData.default_excluded_audiences.length; i++) {
                if (this.viewDatalistData.default_excluded_audiences[i].code === code) {
                  this.viewDatalistData.default_excluded_audiences[i].checked = true
                }
              }
            } else {
              Swal.fire(
                        this.lang['components']['Event']['Relationship']['methods']['defaultExcludedAudiences']['swal_title'],
                        this.lang['components']['Event']['Relationship']['methods']['defaultExcludedAudiences']['swal_text'],
                        "error"
                      )
            }
          } else {
            for (let i = 0; i < this.viewDatalistData.default_excluded_audiences.length; i++) {
              if (this.viewDatalistData.default_excluded_audiences[i].code === code) {
                this.viewDatalistData.default_excluded_audiences[i].checked = false
              }
            }
          }
        }
      },
      updateExcludedAudiences(){
        // console.log('updateExcludedAudiences');
        // console.log(this.viewDatalistData);
        if(this.editPageType == false){
          this.showRelationshipMyside = false;

          axios
            .post('https://www.autoturn.net/api/customize/campaign/campaign_excluded_audiences_list_update.php', Qs.stringify({
              s_code: this.$route.params.id,
              adaccount_id: this.$route.params.adaccount_id,
              campaign_id:this.campaignId
            }))
            .then((response) => {
              // console.log(response);
              if(response.data.status == 'success'){
                this.viewDatalistData.excluded_audiences = response.data.excluded_audiences
                this.viewDatalistData.default_excluded_audiences = response.data.default_excluded_audiences
                this.viewDatalistData.custom_excluded_audiences = response.data.custom_excluded_audiences
                this.viewDatalistData.custom_excluded_audiences_selected = response.data.custom_excluded_audiences_selected
              }

              this.showRelationshipMyside = true;
            });
        }
      },
      onChange(event) {
        // this.selectAll = event.value.length === this.items.length
        let itemLength = 0

        if(this.editPageType == false){
          for (let i = 0; i < this.viewDatalistData.default_excluded_audiences.length; i++) {
            if (this.viewDatalistData.default_excluded_audiences[i].checked == true) {
              itemLength = parseInt(itemLength) + parseInt(1);
            }
          }

          itemLength = parseInt(itemLength) + event.value.length

          if(itemLength > 10){
            event.value.pop();

            Swal.fire(
                        this.lang['components']['Event']['Relationship']['methods']['onChange']['swal_title'],
                        this.lang['components']['Event']['Relationship']['methods']['onChange']['swal_text'],
                        "error"
                      )
          }
        }
      }
    },
    computed: {
      editPageType: {
        get: function () {
          return this.editPage
        },
        set: function (value) {
          this.$emit('update:editPageType', value)
        },
      },
      viewDatalistData: {
        get: function () {
          return this.viewDatalist
        },
        set: function (value) {
          this.$emit('update:viewDatalistData', value)
        },
      }
    }
  }
</script>
<style lang="scss" scoped>
  ::v-deep(.multiselect-custom) {
    .p-multiselect-token {
      font-size: .875rem;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      border-radius: 0.25rem;
      display: inline-flex;
      margin: 0.25rem;
      --tw-bg-opacity: 1;
      background-color: rgba(96, 165, 250, var(--tw-bg-opacity));
      --tw-text-opacity: 1;
      color: rgba(255, 255, 255, var(--tw-text-opacity));
    }
  }
</style>